export const testModels = [
  '27ELN28563BH',
  '34MVP28724AH',
  '58CAR28583AH',
  '21TRU28443RH',
  '72ING28563EH',
  '22ANV16763PH',
  '22ANV16763IH',
  '22ANV16763AH',
  '22BRX16763PH',
  '22LFS16763QH',
  '22BRX16663FH',
  '25CLA28563DH',
  '25RGR32723AH',
  '25SSR28563AH',
  '25RGR28684AH',
  '25CMB32603BH',
  '27FRE32603AH',
  '27ELN32663BH',
  '27FRE28603AH',
  '27FRE28603BH',
  '29ANN16763PH',
  '30CEA32764AH',
  '30CEA28563AH',
  '30CEE32764AH',
  '30CEJ28564AH',
  '31ANN16763AH',
  '31ANN16763IH',
  '31RSV16763XH',
  '31RSV16763JH',
  '32EZL32603BH',
  '32EZL32724BH',
  '32EZL32563CH',
  '32SAP32744AH',
  '34FSN32764BH',
  '34TRA28483AH',
  '34MVP28563AH',
  '34RES28603AH',
  '34EGL28523AH',
  '35MYO18763AH',
  '37SAV32704AH',
  '37SAV28563AH',
  '37SAV28603AH',
  '37SAV16763BH',
  '38SLT28483BH',
  '38SLS28483BH',
  '38SLS32603AH',
  '43CEA32764AH',
  '43CEA28563AH',
  '43CEE32764AH',
  '43CEA28684AH',
  '46SHR16763BH',
  '46EXC28563AH',
  '46EXC28684AH',
  '46ANN28724AH',
  '46FND16763AH',
  '54PAR28563SH',
  '54PAR28602AH',
  '54LGD32563AH',
  '54LGC28603AH',
  '55CRC28483AH',
  '55MSP28603AH',
  '55CRC28563DH',
  '55MSP28683AH',
  '73ADM16783AH',
  '73ADM32663AH',
  '73AFH32663AH',
  '73ADM32764CH',
  '73ADM32844AH',
  '74NRG32523AH',
  '74NRG32583AH',
  '74NRG32623AH',
  '74NRG32764CH',
  '74CAV32563DH',
  '74CAV32643BH',
  '74CAV32663FH',
  '74CAV32784BH',
  '74CAV32603CH',
  '76CEA28563AH',
  '76CEA28684AH',
  '76CEA32764AH',
  '76CEE32764AH',
  '81RDH28523BH',
  '81RDH28643AH',
  '91FPT24463AH',
  '91FPT20523BH',
  '91FPT24403AH',
  '91FPT24623AH',
  '93ECH30703AH',
  '93SUM30683AH',
  '93KAR27603AH',
  '93KAR16763HH',
  '96PLH16663BH',
  '96PLH16763DH',
  '95PLH28483FH',
  '95PLH28523CH',
];
